import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import Badge from "@/components/ui/badge";
import {
  GeneralIllustrationLg,
  YesNoLg,
  TELg,
  TEApprovalLg
} from "@dreamhub/designsystem/icons";

interface WorkflowCard {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface WorkflowTypesTabProps {
  onStartBuilding?: (workflowType: string, title: string) => void;
}

const WorkflowTypesTab: React.FC<WorkflowTypesTabProps> = ({
  onStartBuilding
}) => {
  const { t } = useTranslation();

  const workflowCards: WorkflowCard[] = [
    {
      id: "general",
      title: t("workflows.types.general"),
      description: t("workflows.descriptions.general"),
      icon: <GeneralIllustrationLg />
    },
    {
      id: "yes-no-questionnaire",
      title: t("workflows.types.yesNoQuestionnaire"),
      description: t("workflows.descriptions.yesNoQuestionnaire"),
      icon: <YesNoLg />
    },
    {
      id: "technical-evaluation",
      title: t("workflows.types.technicalEvaluation"),
      description: t("workflows.descriptions.technicalEvaluation"),
      icon: <TELg />
    },
    {
      id: "technical-evaluation-approval",
      title: t("workflows.types.technicalEvaluationApproval"),
      description: t("workflows.descriptions.technicalEvaluationApproval"),
      icon: <TEApprovalLg />
    }
  ];

  const handleStartBuilding = (workflowType: string, title: string) => {
    onStartBuilding?.(workflowType, title);
  };

  return (
    <>
      <div className="p-6">
        <div className="grid grid-cols-3 gap-4">
          {workflowCards.map((card) => (
            <div
              key={card.id}
              className="bg-surface-elevation2 hover:bg-surface-hover-soft rounded-2xl p-4 flex flex-col gap-5 border border-border-border1 shadow-sm"
            >
              <div className="h-32 flex items-center justify-center bg-surface-tertiary rounded-lg">
                {card.icon}
              </div>

              <div className="flex flex-col gap-2">
                <Text variant="smSubtitle" className="text-primary">
                  {card.title}
                </Text>
                <Text variant="bodySecondary" className="text-secondary">
                  {card.description}
                </Text>
              </div>

              <div className="flex justify-end">
                {card.id === "technical-evaluation" ||
                card.id === "technical-evaluation-approval" ? (
                  <Badge
                    text={t("workflows.actions.comingSoon")}
                    className="mt-auto"
                    textVariant="bodySecondary"
                  />
                ) : (
                  <Button
                    variant="primary"
                    onClick={() => handleStartBuilding(card.id, card.title)}
                    className="mt-auto w-fit"
                  >
                    {t("workflows.actions.startBuilding")}
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WorkflowTypesTab;
